import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const token = localStorage.getItem('admin_token');
        
        // If no token exists, redirect to login immediately
        if (!token) {
          navigate('/admin/login');
          return;
        }

        const res = await axios.get('https://agro.atrmart.in/api/admin/dashboard-stats', {
          headers: { 
            Authorization: `Bearer ${token}`,
            'Accept': 'application/json' 
          }
        });
        setStats(res.data);
      } catch (err) {
        console.error("Access Denied", err);
        // If token is invalid (401), force logout/redirect
        if (err.response?.status === 401) {
          localStorage.removeItem('admin_token');
          navigate('/admin/login');
        }
      }
    };
    fetchStats();
  }, [navigate]);

  return (
    <div className="admin-dashboard-container">
      <h1>Admin Control Panel</h1>
      
      {!stats ? (
        <p>Loading secure data...</p>
      ) : (
        <div className="stats-grid">
          {/* Example: Displaying data from your backend */}
          <div className="stat-card">
            <h3>Total Sellers</h3>
            <p>{stats.total_sellers || 0}</p>
          </div>
          <div className="stat-card">
            <h3>Pending Products</h3>
            <p>{stats.pending_products || 0}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminDashboard; // Fixed the spelling here